import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  IRequestPaymentDictionaries,
  paymentDictionariesAccepted,
  paymentDictionariesRejected,
} from '../../actions/paymentDictionary/loadDictionaries'
import {
  addPaymentDictionary,
  deletePaymentDictionary,
  fetchPaymentDictionary,
  IPaymentDictionary,
} from '../../models/PaymentDictionary'
import { IStore } from '../../reducers'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* loadDictionaries(action: IRequestPaymentDictionaries) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchPaymentDictionary)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          fetchPaymentDictionary,
        ),
      ),
    ])

    const dictionaries: IPaymentDictionary[] = yield Effects.call(
      service,
      action.lastModifyDate,
    )
    yield Effects.put(paymentDictionariesAccepted(dictionaries))
  } catch (e) {
    yield Effects.put(paymentDictionariesRejected(e.message))
  }
}

function* addPaymentsaga(action) {
  const actionNames = fetchActionsName(ActionNames.AddPaymentDictionary)
  const [{ service }] = yield Effects.all([
    Effects.take(actionNames.output),
    Effects.put(
      callFetch(actionNames.input, actionNames.output, addPaymentDictionary),
    ),
  ])

  const payments = yield Effects.select(
    (state: IStore) => state.paymentDictionary.dictionaries,
  )

  const dict = yield Effects.call(service, action.name)

  yield Effects.put(paymentDictionariesAccepted([...payments, ...dict]))
}

function* deletePayments(action) {
  const actionNames = fetchActionsName(ActionNames.DeletePaymentDictionary)
  const [{ service }] = yield Effects.all([
    Effects.take(actionNames.output),
    Effects.put(
      callFetch(actionNames.input, actionNames.output, deletePaymentDictionary),
    ),
  ])

  const payments = yield Effects.select(
    (state: IStore) => state.paymentDictionary.dictionaries,
  )

  const dict = yield Effects.call(service, action.id)

  yield Effects.put(
    paymentDictionariesAccepted(payments.filter(e => e.id !== dict[0].id)),
  )
}

export default function*() {
  yield Effects.takeEvery(
    PaymentDictionaryActions.RequestPaymentDictionary,
    loadDictionaries,
  )

  yield Effects.takeLatest(PaymentDictionaryActions.AddPayment, addPaymentsaga)
  yield Effects.takeLatest(
    PaymentDictionaryActions.DeletePayment,
    deletePayments,
  )
}
